import hasGlobalProperty from '../shared/hasGlobalProperty';

export default function(): number {

    // 有些浏览器（比如 ipad safari 的个别版本）下 window.outerWidth 一直为 0，因此要加上 window.screen.availWidth 以做兼容
    return hasGlobalProperty('document')
        ? (document.documentElement.clientWidth ?? Math.max(window.outerWidth, window.screen.availWidth))
        : 1280;
}
